var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconRadioOn = function SvgIconRadioOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M10 17a7 7 0 1 1 0-14 7 7 0 0 1 0 14"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--secondary-color)",
    d: "M10 0c5.523 0 10 4.477 10 10s-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0m4.707 6.793a1 1 0 0 0-1.414 0L8.5 11.6 6.207 9.293a1 1 0 1 0-1.414 1.414l3 3a1 1 0 0 0 1.414 0l5.5-5.5a1 1 0 0 0 0-1.414"
  }))));
};
export default SvgIconRadioOn;